import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, MessageCircle } from "lucide-react";

export default function Support() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/support/contact", form);
      toast.success("Message received — we'll reply soon");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Could not send"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="support-page">
      <p className="text-overline">Help</p>
      <h1 className="font-heading text-4xl text-white mt-2 mb-3 font-light">Contact support</h1>
      <p className="text-sm text-[#a3a3a3]">Our team is available 10:00 – 22:00 CET, every day.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8 mb-10">
        <div className="card-luxe rounded-lg p-5">
          <Mail className="w-5 h-5 text-gold mb-2" strokeWidth={1.5} />
          <p className="text-overline">Email</p>
          <p className="text-sm text-white mt-1">support@relaxora.me</p>
        </div>
        <div className="card-luxe rounded-lg p-5">
          <MessageCircle className="w-5 h-5 text-gold mb-2" strokeWidth={1.5} />
          <p className="text-overline">Live chat</p>
          <p className="text-sm text-white mt-1">Coming soon</p>
        </div>
      </div>

      <form onSubmit={submit} className="card-luxe rounded-lg p-6 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required placeholder="Name" className="bg-[#0a0a0a] border border-white/10 rounded-md px-3 py-2.5 text-white" data-testid="support-name" />
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required type="email" placeholder="Email" className="bg-[#0a0a0a] border border-white/10 rounded-md px-3 py-2.5 text-white" data-testid="support-email" />
        </div>
        <input value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} required placeholder="Subject" className="w-full bg-[#0a0a0a] border border-white/10 rounded-md px-3 py-2.5 text-white" data-testid="support-subject" />
        <textarea value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required rows="6" placeholder="How can we help?" className="w-full bg-[#0a0a0a] border border-white/10 rounded-md px-3 py-2.5 text-white" data-testid="support-message" />
        <button disabled={busy} className="btn-gold rounded-md px-6 py-3 text-sm disabled:opacity-50" data-testid="support-submit">{busy ? "Sending…" : "Send message"}</button>
      </form>
    </div>
  );
}
